import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const card: {
  defaultProps?: ComponentsProps['MuiCard'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiCard'];
  variants?: ComponentsVariants<Theme>['MuiCard'];
} = {
  styleOverrides: {
    root({ theme }) {
      return {
        boxShadow: theme.customShadows.card,
        position: 'relative',
        borderRadius: '6px',
        background: '#111114',
        border: '1px solid rgba(255,255,255,0.05)',
        zIndex: 0, // Fix Safari overflow: hidden with border radius
        padding: '1rem',
      };
    },
  },
};
